import ReadyScreen from './ReadyScreen';

export default ReadyScreen;
